import styled from 'styled-components';

export const InputSuccessSummaryContainer = styled.div`
  background-color: rgba(0,82,0,1);
  padding: 8px;
  h4 {
    margin-top: 5px;
    margin-bottom: 10px;
  }
`;
